<template>
  <v-card class="mx-auto my-3" elevation="4" rounded="lg">
    <template slot="progress">
      <v-progress-linear color="deep-purple" height="6" indeterminate></v-progress-linear>
    </template>

    <v-card-title class="primary white--text">
      <v-avatar color="white" size="40" class="mr-3">
        <v-icon dark color="primary">mdi-account</v-icon>
      </v-avatar>
      <span class="text-h6">Informações do(a) Aluno(a)</span>
    </v-card-title>

    <v-card-text class="pt-4">
      <v-row align="center" class="mx-0 mb-2">
        <v-icon color="primary" class="mr-2">mdi-card-account-details</v-icon>
        <span class="text-subtitle-1 font-weight-medium">{{
          matricula ? matricula.aluno.nomecompleto : "- - -"
        }}</span>
      </v-row>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-row class="pa-3">
      <v-col cols="12" md="6" class="d-flex align-center">
        <div class="mr-3">
          <v-icon large color="indigo">mdi-account-group</v-icon>
        </div>
        <div>
          <div class="text-caption grey--text">TURMA</div>
          <v-chip color="indigo" dark label class="mt-1">
            {{ matricula ? matricula.turma.descricao : "- - -" }}
          </v-chip>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-flex align-center">
        <div class="mr-3">
          <v-icon large color="amber">mdi-star-circle</v-icon>
        </div>
        <div>
          <div class="text-caption grey--text">AVALIAÇÃO DO ALUNO</div>
          <div class="d-flex align-center mt-1">
            <span
              class="text-h5 mr-2 font-weight-bold"
              :class="getRatingColorClass(MediaDasMedias)"
            >
              {{ MediaDasMedias >= 0 ? MediaDasMedias : "-" }}
            </span>
            <v-rating
              :value="MediaDasMedias / 2"
              length="5"
              background-color="grey lighten-1"
              color="amber"
              dense
              readonly
              size="24"
              half-increments
            ></v-rating>
            <v-tooltip top v-if="MediaDasMedias >= 0">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  small
                  :color="getRatingColor(MediaDasMedias)"
                  dark
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ emotions[(MediaDasMedias / 2).toFixed(0) - 1] }}
                </v-chip>
              </template>
              <span>Classificação baseada na média</span>
            </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-card-actions class="pa-0">
      <v-spacer></v-spacer>
      <v-icon small color="grey lighten-1" class="mr-2">mdi-school</v-icon>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["matricula", "notas"],
  data() {
    return {
      emotions: ["Péssimo(a)", "Ruim", "Mediano(a)", "Bom", "Excelente"],
      MediaDasMedias: 0,
      total: 0,
      arrayNotas: [],
    };
  },
  watch: {
    notas(value) {
      this.arrayNotas = value.data;
      this.calcularMediaDasMedias();
    },
  },
  methods: {
    calcularMediaDasMedias() {
      this.MediaDasMedias = _.mean(this.arrayNotas).toFixed(0);
    },
    getRatingColor(rating) {
      const value = rating / 2;
      if (value < 1.5) return "red";
      if (value < 2.5) return "orange";
      if (value < 3.5) return "light-blue";
      if (value < 4.5) return "light-green";
      return "green";
    },
    getRatingColorClass(rating) {
      const value = rating / 2;
      if (value < 1.5) return "red--text";
      if (value < 2.5) return "orange--text";
      if (value < 3.5) return "blue--text";
      if (value < 4.5) return "green--text";
      return "success--text";
    },
  },
};
</script>

<style scoped>
.v-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.v-chip {
  transition: all 0;
}
</style>
